import axios from "axios";
import { ENV } from "../../config/env";

const apiBaseUrl = String(ENV.API_BASE_URL || "").replace(/\/$/, "");

export const http = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    const normalized = token.startsWith("Bearer ") ? token : `Bearer ${token}`;
    config.headers.Authorization = normalized;
  }
  const firebaseUid = localStorage.getItem("firebaseUid");
  if (firebaseUid) {
    config.headers["X-Firebase-UID"] = firebaseUid;
  }
  return config;
});

if (process.env.NODE_ENV === "development") {
  // Ajuda a confirmar qual base URL o CRA carregou do .env (requer reiniciar npm start).
  console.info("[suporte] API_BASE_URL:", apiBaseUrl || "(vazio)");
}
